import { classNames as cn } from 'helpers';
import src from 'img/info_icon.svg';

type InfoIconProps = Readonly<{
	className?: string;
	title: string;
}>;

export function InfoIcon({ className, title }: InfoIconProps) {
	return <img alt="" className={cn('mx-3 pb-1 clickable', className)} src={src} title={title} />;
}
